export default __webpack_public_path__ + "static/media/mobile_beehive_report.a4bd1798.png";